import { financeIntegrationService } from '../services'

const actions = {
  removeInvalidLinks ({ commit }, payload) {
    return financeIntegrationService.removeInvalidLinks(payload)
      .then(
        data => {
          return data.result
        }
      )
  },

  createFortnoxCustomers ({ commit }, customers) {
    return financeIntegrationService.createFortnoxCustomers(customers)
      .then(
        data => {
          return data.result
        }
      )
  },

  matchCustomers ({ commit }) {
    return financeIntegrationService.matchCustomers()
      .then(
        data => {
          return data.result
        }
      )
  },

  getCustomers ({ commit }) {
    return financeIntegrationService.getCustomers()
      .then(
        data => {
          return data.result
        }
      )
  },

  testConnection ({ commit }) {
    return financeIntegrationService.testConnection()
      .then(
        data => {
          return data.result
        }
      ).catch(error => {
        return Promise.reject(error)
      })
  },

  setFortnoxActivationCode ({ commit }, code) {
    return financeIntegrationService.setFortnoxActivationCode(code)
      .then(
        data => {
          return data.result
        }
      ).catch(error => {
        return Promise.reject(error)
      })
  }
}

export const financeIntegration = {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/finance-integration.module.js